export default function ({ store, route, $cookies }) {
  // 定义需要登录的页面
  const publicPages = ['/user', '/apply']
  const authRequired = publicPages.includes(route.path)
  
  // 检查store和cookie中的token
  const token = store.state.token || $cookies.get('token')
  
  // 需要登录的页面但没有token时重定向到登录页
  if (authRequired && !token) {
    store.commit('setShowLogin', true)
  }
}